import React, { useRef, useState } from 'react';
import { PixelRatio, StyleSheet, View } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import useFontSize from '../../shell/hooks/useFontSize';
import { PromptQuestionModal, PromptQuestionModalProps } from '../PromptQuestionModal';

interface TrashButtonProps {
    onClick: (res: string | boolean) => void,
    modalProps: Omit<PromptQuestionModalProps, "onSubmit">;
    children?: React.ReactNode;
}
export const TrashButton: React.FC<TrashButtonProps> = React.memo(({ onClick, modalProps }) => {
    const timesSize = useRef(useFontSize(1.7 / PixelRatio.get()));
    const [loadModal, setLoadModal] = useState(false);


    const styles = StyleSheet.create({
        timesIcon: {
            position: "absolute",
            color: "white",
            padding: 10 / PixelRatio.get(),
            right: 0

        }

    });
    const onSubmitModal = (res: string | boolean) => {
        setLoadModal(false);
        onClick(res);

    };
    const onTrashPressed = () => {
        setLoadModal(true);

        // if (!file) { return; }
        // onDeleteSave(file).then(res => {
        //     if (res) {
        //         onSavePressed?.();
        //     }
        // });

    };
    return (
        <>
            {loadModal ? <PromptQuestionModal {...modalProps} onSubmit={(input) => onSubmitModal(input)}></PromptQuestionModal> : <></>}
            <Icon name="trash" size={timesSize.current} style={styles.timesIcon} onPress={() => onTrashPressed()} />
        </>
    );
});